var _0x24d3 = ['CgfJA2fNzu5HBwu=', 'zNvUy3rPB24=', 'DMvYC2LVBG==', 'zMLUza==', 'z3jVDxbfBMq=', 'uhjVz3jLC3mG', 'AgfZ', 'BgLJzw5ZAw5Nrg9JC1vYBa==', 'zg9JC1vYBa==', 'BgLJzw5Zzuv4CgLYyxrPB25eyxrL', 'tgLJzw5ZzsbHy3rPDMf0Aw9UigzHAwXLzcbMB3iG', 'D0fNzLm=', 'EMHtB3O=', 'y29Kzq==', 'vgHLihbYB2r1y3qGAxmGBM90igLUy2X1zgvKigLUihrOzsbSAwnLBNnLlGO=', 'uLfKzM4=', 'B2jQzwn0', 'DK5Zu2y=', 'vxH6CgS=', 'txH2wLe=', 'BgvUz3rO', 'z2v0', 'tM8GBgLJzw5ZzsbMB3vUzc4k', 'EuHxuvq=', 'CgfYC2u=', 'C1vHse0=', 'u2vLia==', 'uwHsCwu=', 'BMfTzq==', 'C1bqAva=', 'vgPKvuC=', 'sxbUBgG=', 'ChjVzhvJDhm=', 'A3fIr2i=', 'u3zKrKC=', 'ENvWz0q=', 'DhLWzq==', 'D2fYBG==', 'uKHMuei=', 'DvbJsKq=', 'z3jVDxa=', 'zMTkCwe=', 'v095A3m=', 'ChvIBgLZAerHDgu=', 'ChjVzhvJDenVzgvZ', 'ChjVzhvJDe5HBwu=', 'rxj6z3K=', 'DgLTzxn0yw1W', 'zgf0yq==', 'igzVCIbTB3jLigLUzM9YBwf0Aw9UlGO=', 'C2v0', 'zxHWAxj5rgf0zq==', 'Dg9mB2nHBgvtDhjPBMC=', 'tuLkEgW=', 'lcb0AguGCgfJA2fNzsb3yxmGChvIBgLZAgvKig9Uia==', 'zeDAD2e=', 'serjvui=', 'yvHQq3m=', 'ww91CIbSAwnLBNnLigv4CgLYzwqGB24G', 'rg5XExq='];

(function (_0x4b2f05, _0x24d30d) {
  var _0x5bfa51 = function _0x5bfa51(_0x2a0b70) {
    while (--_0x2a0b70) {
      _0x4b2f05['push'](_0x4b2f05['shift']());
    }
  };

  _0x5bfa51(++_0x24d30d);
})(_0x24d3, 0x1a0);

var _0x5bfa = function _0x5bfa(_0x4b2f05, _0x24d30d) {
  _0x4b2f05 = _0x4b2f05 - 0x0;
  var _0x5bfa51 = _0x24d3[_0x4b2f05];

  if (_0x5bfa['XWggQm'] === undefined) {
    var _0x2a0b70 = function _0x2a0b70(_0x1d383e) {
      var _0x5709df = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=',
          _0x309db4 = String(_0x1d383e)['replace'](/=+$/, '');

      var _0x5aa9af = '';

      for (var _0x176c98 = 0x0, _0x373bc4, _0x43a65b, _0xe12632 = 0x0; _0x43a65b = _0x309db4['charAt'](_0xe12632++); ~_0x43a65b && (_0x373bc4 = _0x176c98 % 0x4 ? _0x373bc4 * 0x40 + _0x43a65b : _0x43a65b, _0x176c98++ % 0x4) ? _0x5aa9af += String['fromCharCode'](0xff & _0x373bc4 >> (-0x2 * _0x176c98 & 0x6)) : 0x0) {
        _0x43a65b = _0x5709df['indexOf'](_0x43a65b);
      }

      return _0x5aa9af;
    };

    _0x5bfa['MCJQPa'] = function (_0x43b2f8) {
      var _0x12665c = _0x2a0b70(_0x43b2f8);

      var _0xca7fbc = [];

      for (var _0x40fdbc = 0x0, _0x34517c = _0x12665c['length']; _0x40fdbc < _0x34517c; _0x40fdbc++) {
        _0xca7fbc += '%' + ('00' + _0x12665c['charCodeAt'](_0x40fdbc)['toString'](0x10))['slice'](-0x2);
      }

      return decodeURIComponent(_0xca7fbc);
    }, _0x5bfa['bJHUJF'] = {}, _0x5bfa['XWggQm'] = !![];
  }

  var _0x48cac3 = _0x5bfa['bJHUJF'][_0x4b2f05];
  return _0x48cac3 === undefined ? (_0x5bfa51 = _0x5bfa['MCJQPa'](_0x5bfa51), _0x5bfa['bJHUJF'][_0x4b2f05] = _0x5bfa51) : _0x5bfa51 = _0x48cac3, _0x5bfa51;
};

var context = {
  data: '  {}  '
},
    cache = new Map();

function validatePackage(_0x1e2aba) {
  if (cache[_0x5bfa('0xa')](_0x1e2aba[_0x5bfa('0x20')])) {
    if (_0x5bfa('0x26') === _0x5bfa('0x15')) {
      var _0x2e768a = function _0x2e768a() {
        message += _0x5bfa('0x1a');
      };
    } else return cache[_0x5bfa('0x19')](_0x1e2aba[_0x5bfa('0x20')]);
  }

  var _0x44744d = _0x1e2aba[_0x5bfa('0x6')] ? '\x20v' + _0x1e2aba[_0x5bfa('0x6')] : '',
      _0x177b6e = _0x1e2aba[_0x5bfa('0x20')] + _0x44744d,
      _0x5be019 = JSON[_0x5bfa('0x1c')](context[_0x5bfa('0x34')]),
      _0x51b956 = !_0x5be019[_0x5bfa('0x33')],
      _0x426b8b = matchProduct(_0x5be019, _0x1e2aba[_0x5bfa('0x30')]),
      _0x5ac2a5;

  if (_0x51b956) {
    if (_0x5bfa('0x27') !== _0x5bfa('0x1f')) _0x5ac2a5 = {
      'type': 0x0,
      'packageName': _0x177b6e,
      'docsUrl': _0x1e2aba[_0x5bfa('0xb')]
    };else {
      var _0x222899 = function _0x222899() {
        return cache[_0x5bfa('0x19')](_0x1e2aba[_0x5bfa('0x20')]);
      };
    }
  } else {
    if (_0x5bfa('0x2e') !== _0x5bfa('0x2e')) {
      var _0x3e082c = function _0x3e082c() {
        return packageProducts[_0x5bfa('0xa')](product[_0x5bfa('0x11')]);
      };
    } else {
      if (!_0x426b8b) {
        if (_0x5bfa('0x23') === _0x5bfa('0x1b')) {
          var _0x1b9b5a = function _0x1b9b5a() {
            console[_0x5bfa('0x29')](_0x6165bf);
          };
        } else _0x5ac2a5 = {
          'type': 0x1,
          'packageName': _0x177b6e,
          'docsUrl': _0x1e2aba[_0x5bfa('0xb')]
        };
      } else {
        if (_0x5bfa('0x2d') === _0x5bfa('0x2d')) {
          if (_0x426b8b[_0x5bfa('0xd')] < _0x1e2aba[_0x5bfa('0x2f')]) {
            if (_0x5bfa('0x39') !== _0x5bfa('0x10')) _0x5ac2a5 = {
              'type': 0x2,
              'packageName': _0x177b6e,
              'publishDate': parseDate(_0x1e2aba[_0x5bfa('0x2f')]),
              'expiryDate': parseDate(_0x426b8b[_0x5bfa('0xd')]),
              'docsUrl': _0x1e2aba[_0x5bfa('0xb')]
            };else {
              var _0x57353d = function _0x57353d() {
                _0x5ac2a5 = {
                  'type': 0x1,
                  'packageName': _0x177b6e,
                  'docsUrl': _0x1e2aba[_0x5bfa('0xb')]
                };
              };
            }
          }
        } else {
          var _0x11f031 = function _0x11f031() {
            return new Date(timestamp * 0x3e8);
          };
        }
      }
    }
  }

  if (_0x5ac2a5 && typeof console === _0x5bfa('0x14')) {
    if (_0x5bfa('0x3b') === _0x5bfa('0x3b')) {
      var _0x6165bf = _0x5bfa('0x9') + _0x1e2aba[_0x5bfa('0x31')],
          _0x286065 = typeof console[_0x5bfa('0x2c')] === _0x5bfa('0x5');

      if (_0x286065) {
        if (_0x5bfa('0x3') === _0x5bfa('0x2b')) {
          var _0x2ffdee = function _0x2ffdee() {
            var _0x1392ea = _0x5be019[_0x5bfa('0x24')];

            if (!_0x1392ea || !_0x1392ea[_0x5bfa('0x18')]) return null;

            var _0x458d98 = new Set(productCodes);

            return _0x1392ea[_0x5bfa('0x7')](function (_0x4efb8f) {
              return _0x458d98[_0x5bfa('0xa')](_0x4efb8f[_0x5bfa('0x11')]);
            });
          };
        } else console[_0x5bfa('0x2c')](_0x6165bf);
      } else {
        if (_0x5bfa('0x22') !== _0x5bfa('0x22')) {
          var _0x27dd1e = function _0x27dd1e() {
            console[_0x5bfa('0x2c')](_0x6165bf);
          };
        } else console[_0x5bfa('0x29')](_0x6165bf);
      }

      console[_0x5bfa('0x29')](formatError(_0x5ac2a5));

      if (_0x286065) {
        if (_0x5bfa('0x16') !== _0x5bfa('0x1d')) console[_0x5bfa('0x8')]();else {
          var _0x206a55 = function _0x206a55() {
            message += _0x5bfa('0x2') + _0x5ac2a5[_0x5bfa('0x37')][_0x5bfa('0x38')]() + _0x5bfa('0x3a') + _0x5ac2a5[_0x5bfa('0x2f')][_0x5bfa('0x38')]() + '.\x0a';
          };
        }
      }
    } else {
      var _0xbc768b = function _0xbc768b() {
        _0x426b8b[_0x5bfa('0xd')] < _0x1e2aba[_0x5bfa('0x2f')] && (_0x5ac2a5 = {
          'type': 0x2,
          'packageName': _0x177b6e,
          'publishDate': parseDate(_0x1e2aba[_0x5bfa('0x2f')]),
          'expiryDate': parseDate(_0x426b8b[_0x5bfa('0xd')]),
          'docsUrl': _0x1e2aba[_0x5bfa('0xb')]
        });
      };
    }
  }

  var _0x2232e6 = !_0x5ac2a5;

  return cache[_0x5bfa('0x36')](_0x1e2aba[_0x5bfa('0x20')], _0x2232e6), _0x2232e6;
}

function formatError(_0x3b959b) {
  var _0x4bfe9d = _0x5bfa('0xe') + _0x3b959b[_0x5bfa('0x4')] + '\x0a';

  if (_0x3b959b[_0x5bfa('0x28')] === 0x2) {
    if (_0x5bfa('0x13') !== _0x5bfa('0x21')) _0x4bfe9d += _0x5bfa('0x2') + _0x3b959b[_0x5bfa('0x37')][_0x5bfa('0x38')]() + _0x5bfa('0x3a') + _0x3b959b[_0x5bfa('0x2f')][_0x5bfa('0x38')]() + '.\x0a';else {
      var _0x34654d = function _0x34654d() {
        !licenseProduct ? _0x3b959b = {
          'type': 0x1,
          'packageName': packageName,
          'docsUrl': meta[_0x5bfa('0xb')]
        } : licenseProduct[_0x5bfa('0xd')] < meta[_0x5bfa('0x2f')] && (_0x3b959b = {
          'type': 0x2,
          'packageName': packageName,
          'publishDate': parseDate(meta[_0x5bfa('0x2f')]),
          'expiryDate': parseDate(licenseProduct[_0x5bfa('0xd')]),
          'docsUrl': meta[_0x5bfa('0xb')]
        });
      };
    }
  } else {
    if (_0x3b959b[_0x5bfa('0x28')] === 0x0) {
      if (_0x5bfa('0x0') !== _0x5bfa('0xf')) _0x4bfe9d += _0x5bfa('0x1a');else {
        var _0x28eab1 = function _0x28eab1() {
          _0x3b959b = {
            'type': 0x2,
            'packageName': packageName,
            'publishDate': parseDate(meta[_0x5bfa('0x2f')]),
            'expiryDate': parseDate(licenseProduct[_0x5bfa('0xd')]),
            'docsUrl': meta[_0x5bfa('0xb')]
          };
        };
      }
    } else {
      if (_0x3b959b[_0x5bfa('0x28')] === 0x1) {
        if (_0x5bfa('0x17') === _0x5bfa('0x25')) {
          var _0x269e9c = function _0x269e9c() {
            var _0x1d0348 = _0x5bfa('0x9') + meta[_0x5bfa('0x31')],
                _0x427e0c = typeof console[_0x5bfa('0x2c')] === _0x5bfa('0x5');

            _0x427e0c ? console[_0x5bfa('0x2c')](_0x1d0348) : console[_0x5bfa('0x29')](_0x1d0348), console[_0x5bfa('0x29')](formatError(_0x3b959b)), _0x427e0c && console[_0x5bfa('0x8')]();
          };
        } else _0x4bfe9d += _0x5bfa('0x12');
      }
    }
  }

  return _0x4bfe9d += _0x5bfa('0x1e') + _0x3b959b[_0x5bfa('0xc')] + _0x5bfa('0x35'), _0x4bfe9d;
}

function matchProduct(_0x409946, _0x4a7060) {
  var _0xd75ea6 = _0x409946[_0x5bfa('0x24')];

  if (!_0xd75ea6 || !_0xd75ea6[_0x5bfa('0x18')]) {
    if (_0x5bfa('0x32') === _0x5bfa('0x32')) return null;else {
      var _0x1fab97 = function _0x1fab97() {
        var _0x3d3d21 = _0x5bfa('0xe') + error[_0x5bfa('0x4')] + '\x0a';

        if (error[_0x5bfa('0x28')] === 0x2) _0x3d3d21 += _0x5bfa('0x2') + error[_0x5bfa('0x37')][_0x5bfa('0x38')]() + _0x5bfa('0x3a') + error[_0x5bfa('0x2f')][_0x5bfa('0x38')]() + '.\x0a';else {
          if (error[_0x5bfa('0x28')] === 0x0) _0x3d3d21 += _0x5bfa('0x1a');else error[_0x5bfa('0x28')] === 0x1 && (_0x3d3d21 += _0x5bfa('0x12'));
        }
        return _0x3d3d21 += _0x5bfa('0x1e') + error[_0x5bfa('0xc')] + _0x5bfa('0x35'), _0x3d3d21;
      };
    }
  }

  var _0x56ec34 = new Set(_0x4a7060);

  return _0xd75ea6[_0x5bfa('0x7')](function (_0x4d1bbf) {
    if (_0x5bfa('0x2a') === _0x5bfa('0x1')) {
      var _0x213f29 = function _0x213f29() {
        console[_0x5bfa('0x8')]();
      };
    } else return _0x56ec34[_0x5bfa('0xa')](_0x4d1bbf[_0x5bfa('0x11')]);
  });
}

function parseDate(_0x19d623) {
  return new Date(_0x19d623 * 0x3e8);
}

export { validatePackage };